import React from 'react';
import reportPdf from './posts/comp4900_final_report.pdf';

export default function EnvironmentAttacksRL() {
  return (
    <main className="content" style={{ paddingTop: 16 }}>
      <iframe
        title="Training-Time Environment Attacks for RL"
        src={reportPdf}
        style={{
          width: '100%',
          height: 'calc(100vh - 140px)',
          border: 'none',
          borderRadius: 6,
          background: '#fff',
        }}
      />
    </main>
  );
}
